import { action } from "satcheljs";

export const onOpenAgendaPanel: () => {} = action("onOpenAgendaPanel");
